import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { LoginGuard } from './login/login.guard';
import { LoginManisesComponent } from './login-manises/login-manises.component';
import { HomeManisesComponent } from './home-manises/home-manises.component';
import { LoginGinemedComponent } from './login-ginemed/login-ginemed.component';
import { HomeGinemedComponent } from './home-ginemed/home-ginemed.component';
import { LoginHVDMComponent } from './login-hvdm/login-hvdm.component';
import { HomeHVDMComponent } from './home-hvdm/home-hvdm.component';


const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'home', component: HomeComponent, canActivate: [LoginGuard] },
  { path: 'manises', component: LoginManisesComponent },
  { path: 'manises/home', component: HomeManisesComponent, canActivate: [LoginGuard] },
  { path: 'ginemed', component: LoginGinemedComponent },
  { path: 'ginemed/home', component: HomeGinemedComponent, canActivate: [LoginGuard] },
  { path: 'hvdm', component: LoginHVDMComponent },
  { path: 'hvdm/home', component: HomeHVDMComponent, canActivate: [LoginGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
